// Toast.jsx
import React from "react";
import { MdCheckCircle } from "react-icons/md";

export const Toast = ({ message }) => {
  return (
    <div className="fixed bottom-8 right-8 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-md flex items-center shadow-lg">
      <MdCheckCircle className="text-green-600 text-2xl mr-2" />
      <span>{message}</span>
    </div>
  );
};
